$(document).ready(function () {
    var $searchForm = $('#search-form');
    var $clearAllFilters = $('#clear-all-filters');

    // Basculer les menus déroulants au clic sur le bouton
    $searchForm.find('.dropdown-toggle').on('click', function (e) {
        e.preventDefault();

        // Fermer tous les autres dropdowns
        $searchForm.find('.dropdown-menu').not($(this).siblings('.dropdown-menu')).hide();
        $searchForm.find('.dropdown-toggle').not(this).attr('aria-expanded', 'false');

        // Ouvrir ou fermer le dropdown courant
        var $dropdownMenu = $(this).siblings('.dropdown-menu');
        $dropdownMenu.toggle();
        // Mettre à jour l'attribut aria-expanded pour l'accessibilité
        var isExpanded = $dropdownMenu.is(':visible');
        $(this).attr('aria-expanded', isExpanded);
    });

    // Fermer les menus déroulants en cliquant en dehors
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.dropdown-container').length) {
            closeDropdownMenus();
        }
    });

    $searchForm.on('keydown', '.dropdown-toggle, .dropdown-menu', function (e) {
        if (e.key === 'Escape') {
            e.preventDefault();
            closeDropdownMenus();
            $(this).closest('.dropdown-container').find('.dropdown-toggle').trigger('focus');
        }
    });

    $(document).on('collection:filtered.searchFilters', function (event, filteredCount, totalCount) {
        updateCollectionCount(filteredCount, totalCount);
    });

    // Appeler la fonction de filtrage à chaque changement dans le formulaire
    $searchForm.on('input change', '.search-field input, .search-field select', filterCards);

    // Appeler la fonction de filtrage lors du chargement de la page
    if ($searchForm.length > 0) {
        filterCards();
    }

    $clearAllFilters.on('click', function () {
        if ($(this).prop('disabled') || $(this).attr('aria-disabled') === 'true') {
            return;
        }

        $searchForm
            .find('.search-field.dropdown input[type="checkbox"]')
            .prop('checked', false);
        $searchForm.find('#search-name, #attack-min, #defense-min').val('');
        $('#deck-race-filter, #deck-level-filter').prop('checked', false);
        closeDropdownMenus();
        filterCards();
    });

    // Sync quick filters with the dropdowns. Their values can change when the
    // collection switches to another deck, so do not capture them at startup.
    function getDeckRaceCheckbox() {
        var race = String($('#deck-race-filter').attr('data-race') || '').toLowerCase();
        return $('#search-form .dropdown-toggle[data-key="race"]')
            .closest('.search-field.dropdown')
            .find('input[type="checkbox"]')
            .filter(function () { return String($(this).val()).toLowerCase() === race; });
    }

    function getLevelCheckboxes() {
        return $('#search-form .dropdown-toggle[data-key="rarity"]')
            .closest('.search-field.dropdown')
            .find('input[type="checkbox"]');
    }

    function syncDeckRaceToggle() {
        var $toggle = $('#deck-race-filter');
        var $checkbox = getDeckRaceCheckbox();
        if ($toggle.length && $checkbox.length) {
            $toggle.prop('checked', $checkbox.is(':checked'));
        }
    }

    function syncDeckLevelToggle() {
        var $toggle = $('#deck-level-filter');
        var maxLevel = parseInt($toggle.attr('data-level-max'), 10);
        var $checkboxes = getLevelCheckboxes();
        if (!$toggle.length || isNaN(maxLevel) || !$checkboxes.length) return;
        var $eligible = $checkboxes.filter(function () { return parseInt($(this).val(), 10) <= maxLevel; });
        var $ineligible = $checkboxes.filter(function () { return parseInt($(this).val(), 10) > maxLevel; });
        var allEligibleChecked = $eligible.length > 0
            && $eligible.filter(':checked').length === $eligible.length;
        $toggle.prop('checked', allEligibleChecked && $ineligible.filter(':checked').length === 0);
    }

    $('#deck-race-filter').on('change', function () {
        var $checkbox = getDeckRaceCheckbox();
        if (!$checkbox.length) return;
        var shouldCheck = $(this).is(':checked');
        $('#search-form .dropdown-toggle[data-key="race"]')
            .closest('.search-field.dropdown').find('input[type="checkbox"]')
            .not($checkbox).prop('checked', false);
        $checkbox.prop('checked', shouldCheck).trigger('change');
    });
    $('#search-form .dropdown-toggle[data-key="race"]')
        .closest('.search-field.dropdown').find('input[type="checkbox"]')
        .on('change', syncDeckRaceToggle);

    $('#deck-level-filter').on('change', function () {
        var maxLevel = parseInt($(this).attr('data-level-max'), 10);
        var $checkboxes = getLevelCheckboxes();
        if (isNaN(maxLevel) || !$checkboxes.length) return;
        var shouldCheck = $(this).is(':checked');
        $checkboxes.each(function () {
            var isEligible = parseInt($(this).val(), 10) <= maxLevel;
            $(this).prop('checked', shouldCheck && isEligible);
        });
        filterCards();
    });
    getLevelCheckboxes().on('change', syncDeckLevelToggle);
    syncDeckRaceToggle();
    syncDeckLevelToggle();

    $(document).on('collection:quick-filters-updated.searchFilters', function () {
        syncDeckRaceToggle();
        syncDeckLevelToggle();
    });

    // Fonction pour récupérer les valeurs sélectionnées dans les dropdowns multi-sélection (Rarity, Race, Bonus)
    function getSelectedValues(dropdownKey) {
        var selectedValues = [];
        $('#search-form .search-field.dropdown').each(function () {
            var key = $(this).find('.dropdown-toggle').data('key');
            if (key === dropdownKey) {
                $(this).find('input[type="checkbox"]:checked').each(function () {
                    selectedValues.push($(this).val());
                });
            }
        });
        return selectedValues;
    }

    // Fonction pour récupérer la valeur sélectionnée pour "Trier par"
    function getSortBy() {
        // Priorité au <select name="sort-by"> s'il existe
        var select = $('#search-form select[name="sort-by"]');
        if (select.length) {
            var val = select.val();
            return val && val.length ? val : null;
        }
        // Rétrocompatibilité: anciens boutons radio
        return $('#search-form input[name="sort-by"]:checked').val();
    }

    function closeDropdownMenus() {
        $searchForm.find('.dropdown-menu').hide();
        $searchForm.find('.dropdown-toggle').attr('aria-expanded', 'false');
    }

    function updateCollectionCount(filteredCount, totalCount) {
        var $counter = $('#collection-card-count');
        if (!$counter.length) {
            return;
        }

        var count = parseInt(filteredCount, 10);
        var total = parseInt(totalCount, 10);
        if (isNaN(count)) {
            count = window.collectionState && Array.isArray(window.collectionState.filteredCards)
                ? window.collectionState.filteredCards.length
                : 0;
        }
        if (isNaN(total)) {
            total = window.collectionState && Array.isArray(window.collectionState.allCards)
                ? window.collectionState.allCards.length
                : count;
        }

        var template = String($counter.attr('data-count-template') || '__COUNT__');
        $counter
            .text(template.replace(/__COUNT__/g, String(count)))
            .attr('data-filtered-count', count)
            .attr('data-total-count', total);
    }

    // Fonction principale de filtrage et de tri des cartes
    function filterCards() {
        // Récupérer les critères de recherche
        var name = String($('#search-name').val() || '').toLowerCase().trim();
        var defenseMin = parseInt($('#defense-min').val(), 10) || 0;
        var attackMin = parseInt($('#attack-min').val(), 10) || 0;

        // Récupérer les filtres sélectionnés
        var selectedRarities = getSelectedValues('rarity');
        var selectedRaces = getSelectedValues('race').map(function (r) { return r.toLowerCase(); });
        var selectedBonuses = getSelectedValues('bonus');

        // The collection page keeps its complete data set in memory and only
        // renders the current virtual window. Filtering must therefore happen
        // against the data model rather than the small set of mounted cards.
        if (window.collectionApp && typeof window.collectionApp.applyFilters === 'function') {
            window.collectionApp.applyFilters({
                name: name,
                attackMin: attackMin,
                defenseMin: defenseMin,
                rarities: selectedRarities,
                races: selectedRaces,
                bonuses: selectedBonuses
            }, getSortBy(), {
                preserveScroll: false
            });
            updateActiveFiltersUI();
            return;
        }

        // Parcourir chaque carte et déterminer si elle correspond aux critères
        $('#collection .collection-cards .card').each(function () {
            var $card = $(this);
            var cardName = $card.data('name').toLowerCase().trim().replace(/\s+/g, ' ');
            var cardAttack = parseInt($.trim($card.find('.card-attack').text()), 10);
            if (isNaN(cardAttack)) cardAttack = 0;

            var cardDefense = parseInt($.trim($card.find('.card-defense').text()), 10);
            if (isNaN(cardDefense)) cardDefense = 0;

            // Récupérer la rareté depuis la classe
            var cardRarityMatch = $card.attr('class').match(/level-(\d+)/);
            var cardRarity = cardRarityMatch ? cardRarityMatch[1] : null;

            // Récupérer la race depuis la classe (stable, non traduite)
            var cardRaceMatch = $card.attr('class').match(/(^|\s)race-([a-z0-9_-]+)/);
            var cardRace = cardRaceMatch ? cardRaceMatch[2].toLowerCase() : null;

            // Récupérer les bonus de la carte
            var cardBonuses = [];
            $card.find('.card-bonuses li').each(function () {
                cardBonuses.push($(this).data('name'));
            });

            // Vérifier si la carte correspond aux critères
            var match = true;

            // Vérifier le nom
            if (name && cardName.indexOf(name) === -1) {
                match = false;
            }

            // Vérifier l'attaque minimale
            if (cardAttack < attackMin) {
                match = false;
            }

            // Vérifier la défense minimale
            if (cardDefense < defenseMin) {
                match = false;
            }

            // Vérifier la rareté
            if (selectedRarities.length > 0 && $.inArray(cardRarity, selectedRarities) === -1) {
                match = false;
            }

            // Vérifier la race
            if (selectedRaces.length > 0 && $.inArray(cardRace, selectedRaces) === -1) {
                match = false;
            }

            // Vérifier les bonus
            if (selectedBonuses.length > 0) {
                var hasBonus = false;
                for (var i = 0; i < selectedBonuses.length; i++) {
                    if ($.inArray(selectedBonuses[i], cardBonuses) !== -1) {
                        hasBonus = true;
                        break;
                    }
                }
                if (!hasBonus) {
                    match = false;
                }
            }

            var $displayTarget = $card.closest('.latest-card-item');
            if (!$displayTarget.length) {
                $displayTarget = $card;
            }

            // Afficher ou masquer la carte
            if (match) {
                $displayTarget.show();
            } else {
                $displayTarget.hide();
            }
        });

        // Après le filtrage, appliquer le tri
        sortCards();

        if (typeof window.catalystAfterSort === 'function') {
            window.catalystAfterSort($('#collection .collection-cards'));
        }

        // Mettre à jour l'affichage des filtres actifs
        updateActiveFiltersUI();

        if (typeof window.applyCircleType === 'function') {
            window.applyCircleType($('#collection'));
        }
    }

    // Fonction de tri des cartes visibles
    function sortCards() {
        var sortBy = getSortBy();
        if (!sortBy) {
            return; // Si aucun critère de tri n'est sélectionné, ne rien faire
        }

        var $container = $('#collection .collection-cards');
        var $items = $container.children('.latest-card-item');
        var $cards = $items.length
            ? $items.filter(':visible')
            : $container.children('.card').filter(':visible');

        // Convertir les éléments jQuery en tableau pour pouvoir trier
        var sorted = $cards.get().sort(function(a, b) {
            var $a = $(a).hasClass('card') ? $(a) : $(a).find('.card').first();
            var $b = $(b).hasClass('card') ? $(b) : $(b).find('.card').first();

            switch(sortBy) {
                case 'discovery-date':
                    var dateA = new Date($a.data('discovery'));
                    var dateB = new Date($b.data('discovery'));
                    return dateB - dateA; // Tri décroissant (plus récent en premier)

                case 'level-asc':
                    var levelA_asc = parseInt($a.data('level'), 10) || 0;
                    var levelB_asc = parseInt($b.data('level'), 10) || 0;
                    return levelA_asc - levelB_asc; // Tri croissant (niveau plus bas en premier)

                case 'level-desc':
                    var levelA_desc = parseInt($a.data('level'), 10) || 0;
                    var levelB_desc = parseInt($b.data('level'), 10) || 0;
                    return levelB_desc - levelA_desc; // Tri décroissant (niveau plus élevé en premier)

                case 'attack-asc':
                    var attackA_asc = parseInt($a.find('.card-attack').text(), 10) || 0;
                    var attackB_asc = parseInt($b.find('.card-attack').text(), 10) || 0;
                    return attackA_asc - attackB_asc; // Tri croissant (attaque la plus basse en premier)

                case 'attack-desc':
                    var attackA_desc = parseInt($a.find('.card-attack').text(), 10) || 0;
                    var attackB_desc = parseInt($b.find('.card-attack').text(), 10) || 0;
                    return attackB_desc - attackA_desc; // Tri décroissant (attaque plus élevée en premier)

                case 'defense-asc':
                    var defenseA_asc = parseInt($a.find('.card-defense').text(), 10) || 0;
                    var defenseB_asc = parseInt($b.find('.card-defense').text(), 10) || 0;
                    return defenseA_asc - defenseB_asc; // Tri croissant (défense la plus basse en premier)

                case 'defense-desc':
                    var defenseA_desc = parseInt($a.find('.card-defense').text(), 10) || 0;
                    var defenseB_desc = parseInt($b.find('.card-defense').text(), 10) || 0;
                    return defenseB_desc - defenseA_desc; // Tri décroissant (défense plus élevée en premier)

                default:
                    return 0;
            }
        });

        // Réarranger les cartes triées dans le conteneur
        $.each(sorted, function(idx, card) {
            $container.append(card);
        });

        if (typeof window.catalystAfterSort === 'function') {
            window.catalystAfterSort($container);
        }
    }

    // Met à jour les "chips" des filtres actifs sous le formulaire
    function updateActiveFiltersUI() {
        var $activeFiltersRoot = $('#active-filters');
        var $container = $activeFiltersRoot.find('.active-filters');
        if ($container.length === 0) return;

        var chips = [];
        var showCategory = $activeFiltersRoot.hasClass('collection-active-filters');

        var getOptionLabel = function ($input) {
            return String($input.attr('data-label') || $input.parent().text() || '').trim();
        };

        var withCategory = function (key, label) {
            if (!showCategory) {
                return label;
            }
            var category = String($activeFiltersRoot.attr('data-' + key + '-label') || '').trim();
            return category ? category + ' : ' + label : label;
        };

        // Raretés
        $('#search-form .dropdown-toggle[data-key="rarity"]').each(function () {
            var $wrap = $(this).closest('.search-field.dropdown');
            $wrap.find('input[type="checkbox"]:checked').each(function () {
                var val = $(this).val();
                var label = getOptionLabel($(this));
                chips.push({ key: 'rarity', value: val, label: withCategory('rarity', label) });
            });
        });

        // Races
        $('#search-form .dropdown-toggle[data-key="race"]').each(function () {
            var $wrap = $(this).closest('.search-field.dropdown');
            $wrap.find('input[type="checkbox"]:checked').each(function () {
                var val = $(this).val();
                var label = getOptionLabel($(this));
                chips.push({ key: 'race', value: val, label: withCategory('race', label) });
            });
        });

        // Bonus
        $('#search-form .dropdown-toggle[data-key="bonus"]').each(function () {
            var $wrap = $(this).closest('.search-field.dropdown');
            $wrap.find('input[type="checkbox"]:checked').each(function () {
                var val = $(this).val();
                var label = getOptionLabel($(this));
                chips.push({ key: 'bonus', value: val, label: withCategory('bonus', label) });
            });
        });

        // Nom
        var $nameInput = $('#search-name');
        var nameVal = String($nameInput.val() || '').trim();
        if ($nameInput.length && nameVal.length > 0) {
            var nameLabel = $activeFiltersRoot.attr('data-name-label')
                || $('#search-name').attr('placeholder')
                || 'Name';
            chips.push({
                key: 'name',
                value: null,
                label: nameLabel + (showCategory ? ' : ' : ': ') + nameVal
            });
        }

        // Rendu
        $container.empty();
        chips.forEach(function (chip) {
            var $chip = $('<span/>', {
                'class': 'active-filter',
                'data-key': chip.key
            });
            if (chip.value !== null) {
                $chip.attr('data-value', chip.value);
            }
            $('<span/>', { 'class': 'label', text: chip.label }).appendTo($chip);
            $('<button/>', {
                'type': 'button',
                'class': 'remove',
                'aria-label': $activeFiltersRoot.attr('data-remove-label') || 'Remove',
                'text': '×'
            }).appendTo($chip);
            $container.append($chip);
        });

        var hasActiveFilters = chips.length > 0;
        $activeFiltersRoot.toggleClass('is-empty', !hasActiveFilters);
        $clearAllFilters
            .toggleClass('is-disabled', !hasActiveFilters)
            .prop('disabled', !hasActiveFilters)
            .attr('aria-disabled', hasActiveFilters ? 'false' : 'true');
    }

    // Supprimer un filtre actif depuis le bouton dédié de sa capsule.
    $(document).on('click', '#active-filters .active-filters .active-filter .remove', function (e) {
        e.preventDefault();
        var $chip = $(this).closest('.active-filter');
        var key = $chip.data('key');
        var val = $chip.data('value');

        switch (key) {
            case 'rarity':
            case 'race':
            case 'bonus':
                // Décoche la case correspondante
                $('#search-form .dropdown-toggle[data-key="' + key + '"]')
                    .closest('.search-field.dropdown')
                    .find('input[type="checkbox"][value="' + val + '"]')
                    .prop('checked', false)
                    .trigger('change');
                break;
            case 'name':
                $('#search-name').val('').trigger('input');
                break;
        }
    });
});
